import type { LoanAutopayDataResponse } from "./types";
import type { ScheduledPayload } from "../../../../TransferSchedule";
import type {
  InternalLoanPaymentPayload,
  LoanPaymentPayloadV2,
  LoanPaymentByCardPayload,
} from "../../../../types/models/v1";
import type { NetworkPayload } from "../../../composites/request/request.types";

const internalLoanPaymentsUrl = "internal_loan_payments/";

export const API = {
  /**
   * @deprecated Use `makeInternalLoanPayment()`
   */
  makeInternalPrincipalPayment: (
    idempotencyKey: UUID,
    payload: InternalLoanPaymentPayload<"principal">,
  ): NetworkPayload => {
    return {
      url: internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  /**
   * @deprecated Use `makeInternalLoanPayment()`
   */
  makeInternalDefaultPayment: (
    idempotencyKey: UUID,
    payload: InternalLoanPaymentPayload<"default">,
  ): NetworkPayload => {
    return {
      url: internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  /**
   * @deprecated Use `makeInternalLoanPayment()` or
   * `makeExternalLoanPayment()`
   */
  makeInternalPayment: (
    idempotencyKey: UUID,
    payload: InternalLoanPaymentPayload<"default" | "principal">,
    fromAccountSource: string = "institution",
  ): NetworkPayload => {
    return {
      url:
        fromAccountSource === "external"
          ? "loan_payments/ach"
          : internalLoanPaymentsUrl,
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  makeInternalLoanPayment: (
    idempotencyKey: UUID,
    payload: LoanPaymentPayloadV2,
  ): NetworkPayload => {
    return {
      url: "internal_loan_payments/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  makeExternalLoanPayment: (
    idempotencyKey: UUID,
    payload: LoanPaymentPayloadV2,
  ): NetworkPayload => {
    return {
      url: "loan_payments/ach",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  makeScheduledTransfer: (
    idempotencyKey: UUID,
    payload: ScheduledPayload,
  ): NetworkPayload => {
    return {
      url: "transfers/scheduled",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  makeCardLoanPayment: (
    idempotencyKey: UUID,
    payload: LoanPaymentByCardPayload,
    userId: API.UserId,
  ): NetworkPayload => {
    return {
      url: `users/${userId}/payment`,
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  getLoanAutopay: (
    accountId: string,
  ): NetworkPayload<LoanAutopayDataResponse> => {
    return {
      url: `accounts/${accountId}/loan/autopay`,
      options: {
        method: "GET",
      },
    };
  },
};
